/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Add,
  Grid,
  Typography,
  Button,
  EditTwoToneIcon,
} from "../../../utils/components/index";
import { Link, useNavigate } from "react-router-dom";
import { domainList, clearState } from "./domainSlice";
import ReactTable from "../../../utils/react-table/ReactTable";
import { domainSelector } from "./domainSlice";
import Loader from "../../../utils/components/loader";

function DomainsList() {
  let navigate = useNavigate();
  const [pageSize, setPageSize] = useState(10);
  const domainsData = useSelector((state) => state.domains.domains);
  let totalDomains = useSelector((state) => state.domains.totalDomains);

  const { isFetching } = useSelector(domainSelector);

  const totalPages = useSelector((state) => {
    return state.domains.totalDomains > 0
      ? Math.ceil(state.domains.totalDomains / pageSize)
      : 0;
  });

  function editRowAction(data) {
    dispatch(clearState());
    return navigate(`/domain/edit/${data._id}`);
  }

  const columnsData = [
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ value }) => {
        return (
          <div className="age-cell" gap="2px">
            <span style={{ color: "teal", fontWeight: "bold" }}>{value}</span>
          </div>
        )
      }
    },
    {
      Header: "URL",
      accessor: "url",
      Cell: ({ value }) => {
        return (
          <div className="age-cell" gap="2px">
            <span style={{ color: "blue", fontWeight: "bold" }}>{value}</span>
          </div>
        )
      }
    },
    {
      Header: "Status",
      accessor: "isActive",
      Cell: (props) => {
        if (props.value === true) {
          return <span style={{ color: "green", fontWeight: "bold" }}>Active</span>;
        } else {
          return <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>;
        }
      },
    },
    {
      Header: "Action",
      accessor: (originalRow) => (
        <React.Fragment>
          <EditTwoToneIcon
            className="cursor-pointer"
            onClick={() => editRowAction(originalRow)}
            titleAccess="Edit Domain"
          />
        </React.Fragment>
      ),
    },
  ];

  const dispatch = useDispatch();
  const columns = useMemo(() => columnsData, [editRowAction]);
  const fetchData = useCallback((pageIndex, search, page_size) => {
    let paginationData = {
      pageNumber: pageIndex,
      pageSize: page_size,
      searchValue: search,
    };
    Promise.resolve(dispatch(clearState()))
      .then(() => dispatch(domainList(paginationData)))
      .then(() => setPageSize(page_size))
      .then(() => dispatch(clearState()));
  }, []);

  return (
    <React.Fragment>
      <Grid container spacing={2} display="flex">
        {isFetching ? <Loader /> : ""}
        <Grid item xs={8}>
          <Typography variant="h5" component="div">
            Domains
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ textAlign: "right" }}>
          <Button
            variant="contained"
            startIcon={<Add />}
            component={Link}
            to="/domain/add"
          >
            Add
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12}>
          <ReactTable
            columns={columns}
            data={domainsData}
            fetchData={fetchData}
            totalRecords={totalDomains}
            totalPages={totalPages}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default DomainsList;
